exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5ed8ac56] .el-table__body .el-table__row.hover-row>td.el-table__cell{background-color:transparent!important}", ""]);

// exports
